class viewCartHeadingsController {
    /* @ngInject */
    constructor() {
    }
}

export default viewCartHeadingsController;


// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-headings/view-cart-headings.controller.js